import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';
import { CountertopData, CountertopDataIn } from './types';

export const countertopData = <ParentType>(dataIn: CountertopDataIn = null): CountertopData => {
	const rd = new RecordData<CountertopDataIn>(dataIn);

	const record: CountertopData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		material: dataIn?.material ?? null,
		breakpoints: dataIn?.breakpoints ?? null,
		backsplashes: dataIn?.backsplashes ?? null,
		// material: new CountertopMaterial({ dataIn: dataIn?.material ?? null }).serialize(),
		// breakpoints: new Breakpoints({ dataIn: dataIn?.breakpoints ?? null }).serialize(),
		islandIds: rd.useNewOrDefault('islandIds', []),
		override: rd.useNewOrDefault<boolean>('override', false),
		sku: rd.useNewOrDefault<string>('sku', null)
	};

	return record;
};
